<div class="row">
  <div class="col-md-12">
    <h5 class="card-title">Encuentra tu especialista</h5>
    <p>A continuación, encontrarás los especialistas disponibles para tí</p>
    <hr class="linea" />
  </div>
</div>

<div class="row">
  <div class="col-12 col-md-8 especialistas-col">
    <div class="row mb-3" *ngIf="especialistas.length > 1">
      <div class="col-12 col-md-6">
        <input
          type="text"
          class="form-control"
          placeholder="Ingresa nombre del especialista..."
          [(ngModel)]="nombreEspecialista"
          (input)="filtrarEspecialistas()"
        />
      </div>
    </div>
    <div *ngIf="!cargandoEspecialistas && especialistasFiltrados.length > 0">
      <div
        *ngIf="!spinner"
        class="row"
        data-masonry='{"percentPosition": true }'
      >
        <ng-container
          *ngFor="let data of especialistasFiltrados; let last = last"
          class="row"
        >
          <div class="col-12 mobile-card-container">
            <div class="card border-box">
              <div class="row">
                <!-- Información del especialista - izquierda -->
                <div class="col-12 col-md-4">
                  <div class="d-flex align-items-start p-3 p-md-3 px-md-3 px-2">
                    <div class="image-container me-md-3 me-2">
                      <img
                        src="{{ data.foto }}"
                        alt="{{ data.nombre }}"
                        class="rounded"
                        style="width: 70px; height: 70px; object-fit: cover"
                      />
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="nombre-title mb-1">{{ data.nombre }}</h5>
                      <p class="nombre-subtitle mb-1 text-muted">
                        {{ data.perfil.especialidad }}
                      </p>
                      @if (data.categoria) {
                      <p class="nombre-categoria mb-2 small fw-medium">
                        {{ data.categoria }}
                      </p>
                      }
                    </div>
                  </div>
                  <app-expandable-text
                    [text]="data.descripcion"
                    [maxLength]="100"
                  ></app-expandable-text>
                </div>

                <div class="col-12 col-md-8">
                  <app-agenda-especialista
                    [idEspecialista]="data.$id"
                    [datosPaciente]="datosPaciente"
                  ></app-agenda-especialista>
                </div>
              </div>
            </div>
            <!-- Separador solo para móviles -->
            <div *ngIf="!last" class="mobile-separator d-md-none"></div>
          </div>
        </ng-container>
      </div>
    </div>
    <a
      *ngIf="hayMasEspecialistas"
      href="javascript: void(0);"
      (click)="onTraerTodosEspecialistas()"
      class="btn-traer-especialistas"
      >Ver todos los especialistas</a
    >
  </div>
</div>
